import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from "react-redux";
import App from './App.tsx'
import { store } from "store";
import { isDesktop, isMobile } from 'react-device-detect';
import TagManager from 'react-gtm-module'

import "configs/customTags";

// initialisation de google tag manager pour thermor uniquement
let gtmId;
if (window.location.href.indexOf('pac-air-eau') > -1) {
    gtmId = 'GTM-N96FH5N'
} else if (window.location.href.indexOf('pacific') > -1) {
    gtmId = 'GTM-5XR26FT'
} else {
    gtmId = 'GTM-5XR26FT'
}

TagManager.initialize({
    gtmId,
    dataLayerName: 'PageDataLayer'
})


sessionStorage.removeItem("save_open")


isMobile && document.documentElement.classList.add('mobile');
isDesktop && document.documentElement.classList.add('desktop');

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <StrictMode>
            <App />
        </StrictMode>
    </Provider>,
)
